import { colors } from "../../Styles";

export function Check({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <path d="M120.5,277.09L44.52,90.29c-2.74-6.73.5-14.41,7.23-17.15,6.73-2.74,14.41.5,17.15,7.23l47.54,116.87c16.25-46.69,50.15-128.32,101.41-175.45,5.35-4.92,13.68-4.57,18.59.78,4.92,5.35,4.57,13.67-.78,18.59-67.55,62.12-104.6,196.9-104.97,198.26l-10.19,37.67Z"/>
    </svg>
  );
}
